import { Link } from "react-router-dom";

/**
 * Porté à l'identique depuis apps/web/components/home/HomeHero.tsx (visuel
 * statique assumé, cf. commentaire d'origine — aucune entité `banner` en
 * base). Seul changement : `next/link` → `Link` de react-router-dom.
 */
export function HomeHero() {
  return (
    <section className="bg-cream">
      <div className="container-vvs flex flex-col gap-4 py-4 lg:aspect-[21/9] lg:flex-row lg:py-6">
        {/* Carte principale */}
        <div className="relative isolate flex-1 overflow-hidden rounded-sm bg-gradient-to-br from-navy via-navy2 to-navy3">
          <span
            aria-hidden="true"
            className="pointer-events-none absolute -bottom-16 -right-4 select-none font-display text-[14rem] font-bold leading-none text-gold/10"
          >
            S
          </span>
          <div className="relative flex aspect-[4/5] flex-col items-start justify-center gap-4 px-6 py-10 sm:aspect-[16/9] sm:px-10 lg:aspect-auto lg:h-full">
            <span className="rounded-sm bg-gold px-3 py-1.5 font-body text-xs font-bold uppercase tracking-wide text-navy">
              Offre du moment
            </span>
            <h1 className="max-w-xl font-display text-3xl font-bold leading-tight text-cream sm:text-4xl lg:text-5xl">
              Le marketplace ivoirien tout-en-un
            </h1>
            <p className="max-w-md font-body text-sm text-cream2 sm:text-base">
              Bijoux, mode, beauté, high-tech, maison, enfants&nbsp;&amp;&nbsp;bébé… livrés
              partout en Côte d&apos;Ivoire, payables à la livraison ou par mobile money.
            </p>
            <div className="mt-2 flex flex-wrap gap-3">
              <Link
                to="/catalogue"
                className="inline-flex items-center justify-center gap-2 rounded-sm border border-gold bg-gold px-6 py-3 font-body text-sm font-medium uppercase tracking-wide text-navy transition-colors duration-150 hover:border-gold2 hover:bg-gold2"
              >
                Découvrir la boutique
              </Link>
              <Link
                to="/catalogue?onSale=true"
                className="inline-flex items-center justify-center gap-2 rounded-sm border border-cream/50 px-6 py-3 font-body text-sm font-medium text-cream transition-colors duration-150 hover:border-cream"
              >
                Voir toutes les promos
              </Link>
            </div>
          </div>
        </div>

        {/* Cartes latérales — empilées verticalement à tous les paliers (colonne étroite à droite dès lg) */}
        <div className="flex flex-col gap-4 lg:w-80 lg:flex-shrink-0">
          <div className="flex flex-1 flex-col justify-center gap-1.5 rounded-sm bg-cream2 p-5">
            <span className="font-body text-[11px] font-semibold uppercase tracking-wide text-golddark">
              Nouveautés
            </span>
            <span className="font-display text-lg font-semibold text-navy">Les derniers arrivages</span>
            <Link
              to="/catalogue?sort=newest"
              className="mt-1 inline-flex items-center gap-1 font-body text-sm font-semibold text-navy hover:text-gold"
            >
              Les découvrir →
            </Link>
          </div>
          <div className="flex flex-1 flex-col justify-center gap-1.5 rounded-sm bg-navy2 p-5">
            <span className="font-body text-[11px] font-semibold uppercase tracking-wide text-goldl">
              Une question ?
            </span>
            <span className="font-display text-lg font-semibold text-cream">Contactez-nous</span>
            <Link to="/contact" className="mt-1 inline-flex items-center gap-1 font-body text-sm font-semibold text-goldl hover:text-gold">
              Nous écrire →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
